import { PageContainer } from "../components/pageContainer/PageContainer"
import { TermsAndConditions } from "../layout/termsConditions/TermsAndConditions"

export const TermsConditions = () => {
    return (
        <PageContainer>
            <TermsAndConditions />
        </PageContainer>
    )
}